const surgicalApproaches = ['Open', 'Laparoscopic', 'Vaginal'] as const;
export type SurgicalApproaches = typeof surgicalApproaches[number];

export default surgicalApproaches;
